<template>
    <div class="cz2__steps-options__actions--share">
        <share-button
            v-if="!isTwoPack && !isSpellingBee"
            @click.native="saveAvatar"
            :icon="saveIcon"
            :button-copy="$t('ACTION_SAVE_AVATAR')"
        />

        <share-button
            @click.native="sharePop"
            :isDisabled="shareDisabled"
            :icon="shareIcon"
            :button-copy="$t('ACTION_SHARE')"
        />

        <share-button
            @click.native="downloadPopImage"
            :isDisabled="shareDisabled"
            :icon="downloadIcon"
            :button-copy="$t('ACTION_DOWNLOAD')"
        />
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__steps-options__actions--share {
            display: flex;
            gap: 4px;

            @include respond-above(sm) {
                gap: 16px;
            }

            @include respond-above(md) {
                flex-direction: column;
            }
        }
    }
</style>

<script>
    import axios from 'axios';
    import FileSaver from 'file-saver';

    import save from '../assets/icons/share-icons/save.svg';
    import share from '../assets/icons/share-icons/share.svg';
    import download from '../assets/icons/share-icons/download.svg';

    import ShareButton from './ShareButton.vue';

    export default {
        components: {
            ShareButton,
        },

        data() {
            return {
                shareDisabled: true,
                shareFileName: `${this.$t('NO_NAME')}.png`,
                shareImage: null,
                shareImageFetched: null,
                fbScriptSrc: 'https://connect.facebook.net/en_US/sdk.js',
                saveIcon: save,
                shareIcon: share,
                downloadIcon: download,
            };
        },

        computed: {
            popControllers() {
                return this.$store.getters.popControllers;
            },

            mainController() {
                return this.$store.state.customizer.mainController;
            },

            boxName() {
                return this.$store.state.customizer.boxName;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },

            boxNames() {
                return Object.values(this.$store.state.customizer.boxNamesByController).join('_');
            },

            fileName() {
                const boxName = this.isTwoPack ? this.boxNames : this.boxName;

                return boxName && boxName.length > 0 ? boxName : this.$t('NO_NAME');
            },

            savedRecipe() {
                return this.$store.state.customizer.savedRecipe;
            },

            editingFromCart() {
                return this.$store.state.customizer.options.recipeFrom === 'cart';
            },
        },

        watch: {
            savedRecipe() {
                this.getShareData();
            },

            boxName() {
                if (this.boxName) {
                    this.shareFileName = `${this.fileName}.png`;
                }
            },
        },

        mounted() {
            this.checkForFbScript();

            if (this.editingFromCart) {
                this.getShareData();
            }
        },

        methods: {
            saveAvatar() {
                this.mainController.trackAction({
                    action: 'save-avatar',
                    tags: this.mainController.collectActiveTags(),
                });

                this.$store.dispatch('saveRecipe', {
                    type: 'avatar',
                });
            },

            getShareData() {
                const preview = this.savedRecipe.recipe.views.find((view) => view.code === 'Preview');

                this.shareImage = preview.previewPng;
                this.shareFileName = `${this.fileName}.png`;
                this.fetchImage();
            },

            sharePop() {
                this.trackAction('share');

                const files = [new File([this.shareImageFetched], this.shareFileName, { type: 'image/png' })];

                if (navigator.canShare && navigator.canShare({ files })) {
                    navigator.share({
                        files,
                        title: 'Shared Image',
                        text: 'Check out this image!',
                    })
                        .catch((error) => console.error('Error sharing image:', error));
                } else {
                    // eslint-disable-next-line no-undef
                    FB.ui({
                        method: 'share',
                        href: `https:${this.shareImage}`,
                    }, () => {});
                }
            },

            downloadPopImage() {
                this.trackAction('download');

                axios.get(this.shareImage, { responseType: 'blob' }).then((response) => {
                    FileSaver.saveAs(response.data, this.shareFileName);
                });
            },

            fetchImage() {
                fetch(this.shareImage).then((response) => response.blob()).then((image) => {
                    this.shareImageFetched = image;

                    // Enable share buttons
                    this.shareDisabled = false;
                });
            },

            checkForFbScript() {
                if (window.FB == null) {
                    this.addFacebookScript();
                }
            },

            addFacebookScript() {
                const facebookScript = document.createElement('script');

                facebookScript.setAttribute('src', this.fbScriptSrc);

                // FB won't load with these from the "real" test page on CDN...
                // facebookScript.setAttribute('crossorigin', 'anonymous');
                // facebookScript.setAttribute('async', true);
                // facebookScript.setAttribute('defer', true);

                document.body.appendChild(facebookScript);

                window.fbAsyncInit = () => {
                    // eslint-disable-next-line no-undef
                    FB.init({
                        appId: '2802097273142792',
                        autoLogAppEvents: true,
                        xfbml: true,
                        version: 'v14.0',
                    });
                };
            },

            trackAction(actionType) {
                this.popControllers.forEach((controller) => {
                    const tags = controller.collectActiveTags();

                    controller.trackAction({
                        action: actionType,
                        tags,
                    });
                });
            },
        },
    };
</script>
